import React from 'react';
import '../App.css';
import {render} from 'react-dom';

class LabelBar extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <>
            <div className="labelBar">
                <h1>designer.</h1>
                <h1>artist.</h1>
                <h1>engineer.</h1>
            </div>
            </>
        );
    }
}

export default LabelBar;